module.exports = __webpack_public_path__ + "static/img/0767.830e85b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0767.jpg
// module id = 105
// module chunks = 0